<template>
  <div class="p-3 pb-20 bg mb-auto h-full overflow-auto bg-gradient-to-b from-gray-800 text-white" id="style-1">
    <CraftList />
  </div>
</template>

<script>
import CraftList from '@/components/craft/CraftList.vue';

export default {
  name: 'CraftingPage',
  components: {
    CraftList,
  },
};
</script>

<style scoped>
.bg {
  background: url('https://firebasestorage.googleapis.com/v0/b/zombiekub.firebasestorage.app/o/bg%2Fcraftroom.png?alt=media&token=77a2e49e-6dbb-443f-8471-189a8a716c77') no-repeat center center fixed,
              linear-gradient(to bottom, rgba(31, 41, 55, 0.95), rgba(0, 0, 0, 0.95));
  background-size: cover;
}
</style>